import React from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'store';
import { Layout } from 'features/common/components/Layout';
import { isAdminOrSuperAdmin } from 'features/auth/helpers';
import { CreditRulesAdmin } from 'features/creditRules/components/CreditRulesAdmin';

/** /clientes/condiciones-de-credito — gestión de condiciones (admin/superadmin). */
export function CreditRulesRoute(): JSX.Element {
	const user = useSelector((state: RootState) => state.auth.user, shallowEqual);

	if (!isAdminOrSuperAdmin(user)) {
		return <Redirect to="/" />;
	}

	return (
		<Layout>
			<Container maxWidth="xl" sx={{ py: 3 }}>
				<Box mb={3}>
					<Typography variant="h5" fontWeight={700} color="primary">
						Condiciones de crédito
					</Typography>
					<Typography variant="body2" color="text.secondary">
						El acuerdo de pago de cada cliente corporativo: cuándo se le factura y cuándo vence esa factura. Al
						facturar, el vencimiento se completa solo con esta información.
					</Typography>
				</Box>
				<CreditRulesAdmin />
			</Container>
		</Layout>
	);
}
